import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { AssetType, defaultValueFor, } from '@components';
import { AssetScope, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { SessionsService } from '@services';
import cloneDeep from 'lodash-es/cloneDeep';
import { Subject } from 'rxjs';
import { AssetCredentialValidator, getValueFor, resetForm, RobotAssetSource, RobotDuplicateValidator, RobotValidator, validatorsFor, } from '../../utils';
var UiRobotValueEditorComponent = /** @class */ (function () {
    function UiRobotValueEditorComponent(_fb, _sessionService, _translateService) {
        this._fb = _fb;
        this._sessionService = _sessionService;
        this._translateService = _translateService;
        this.robotSearchFactory = this._sessionService.suggest;
    }
    Object.defineProperty(UiRobotValueEditorComponent.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (type) {
            this._type = type;
            if (this.formGroup && this.formGroup.get('robotValue')) {
                this.robotAssets.updateType(type);
                this.editedRobot = this.robotAssets.find(this.editedRobot);
                resetForm(this.formGroup, 'robotValue', this._type, this.isNewEntry, this._readonly);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiRobotValueEditorComponent.prototype, "selectedRobot", {
        get: function () {
            return this.editedRobot == null ||
                this.editedRobot.robotId === -1 ? [] : [{
                    id: this.editedRobot.robotId,
                    text: this.editedRobot.robotName,
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiRobotValueEditorComponent.prototype, "isEditorOpen", {
        get: function () {
            return this.editedRobot != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiRobotValueEditorComponent.prototype, "isEditorValid", {
        get: function () {
            return this.robotAssets.isCollectionValid(this.type, this._readonly);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiRobotValueEditorComponent.prototype, "hasRobots", {
        get: function () {
            return this.robotAssets.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiRobotValueEditorComponent.prototype, "credentialStoreId", {
        get: function () {
            return this._credentialStoreId;
        },
        set: function (value) {
            this._credentialStoreId = value;
            if (this._type === 'Credential' && this.formGroup && this.formGroup.get('robotValue')) {
                this.robotAssets.updateCredentialStore(value);
                this.editedRobot = this.robotAssets.find(this.editedRobot);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiRobotValueEditorComponent.prototype, "readonly", {
        get: function () {
            return this._readonly;
        },
        set: function (readonly) {
            this._readonly = readonly;
            if (this._type === 'Credential' && this.formGroup && this.formGroup.get('robotValue')) {
                resetForm(this.formGroup, 'robotValue', this._type, this.isNewEntry, readonly, true);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiRobotValueEditorComponent.prototype, "AssetScope", {
        get: function () {
            return AssetScope;
        },
        enumerable: true,
        configurable: true
    });
    UiRobotValueEditorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.robotAssets = new RobotAssetSource(cloneDeep(this.asset.robotValues));
        this.formGroup = this._fb.group({
            'robot': [
                this.selectedRobot,
                Validators.compose([
                    RobotValidator,
                    RobotDuplicateValidator(this.robotAssets),
                ]),
            ],
            'robotValue': [
                defaultValueFor(this.type, null, this.readonly), validatorsFor(this.type, true, this.readonly, true),
            ],
        }, {
            validator: AssetCredentialValidator('robotValue', function () { return _this.type; }, function () { return _this.editedRobot; }, function () { return _this.readonly; }),
        });
        this.credentialStoreChange$.subscribe(function (_) {
            if (_this._type === 'Credential' && _this.formGroup && _this.formGroup.get('robotValue')) {
                resetForm(_this.formGroup, 'robotValue', _this._type, _this.isNewEntry, _this._readonly, true);
                _this.robotAssets.updateCredentialStore(_this.asset.credentialStoreId);
            }
        });
    };
    UiRobotValueEditorComponent.prototype.ngOnDestroy = function () {
        this.credentialStoreChange$.complete();
    };
    UiRobotValueEditorComponent.prototype.addEntry = function () {
        this.expandRow(this.robotAssets.generateEntry(this.type, this._credentialStoreId));
        this.formGroup.get('robot').reset([]);
        this.robotAssets.update();
    };
    UiRobotValueEditorComponent.prototype.expandRow = function (entity) {
        resetForm(this.formGroup, 'robotValue', this._type, entity.id < 0, this._readonly, true);
        if (this.editedRobot &&
            this.editedRobot.id === -1) {
            this.robotAssets.remove(this.editedRobot);
        }
        this.editedRobot = entity;
        if (this._type === 'Credential') {
            this.editedRobot.credentialStoreId = this._credentialStoreId;
        }
        this.formGroup.get('robotValue').patchValue(getValueFor(this.editedRobot, this._readonly));
        this.formGroup.markAsUntouched();
    };
    UiRobotValueEditorComponent.prototype.removeRow = function (entity) {
        this.robotAssets.remove(entity);
    };
    UiRobotValueEditorComponent.prototype.isValid = function (entry) {
        switch (entry.type) {
            case AssetType.Credential:
                if (this._readonly) {
                    break;
                }
                return !!entry.credentialUsername;
            case AssetType.Bool:
                return entry.boolValue != null;
        }
        var errors = validatorsFor(entry.type, true, this._readonly, true)({
            value: entry.stringValue || entry.intValue || entry.externalName,
        });
        return errors === null;
    };
    UiRobotValueEditorComponent.prototype.getValueFor = function (asset) {
        switch (asset.type) {
            case AssetType.Bool:
                return asset.boolValue ?
                    this._translateService.instant('assets_modal_form_bool_true') :
                    this._translateService.instant('assets_modal_form_bool_false');
            case AssetType.Integer:
                return asset.intValue;
            case AssetType.Text:
                return asset.stringValue;
            case AssetType.Credential:
                if (this._readonly) {
                    return asset.externalName;
                }
                return asset.credentialUsername + ":****";
        }
    };
    UiRobotValueEditorComponent.prototype.onRobotChange = function (ev) {
        ev = ev || {};
        if (!this.editedRobot) {
            return;
        }
        if (this.editedRobot.id > 0 &&
            this.editedRobot.robotId !== ev.id) {
            // if the robot was changed on an existing entry
            // clear the initial username to avoid username has changed validation
            this.editedRobot.credentialUsername = null;
            this.formGroup.get('robotValue').reset(defaultValueFor(this.type, null, this._readonly));
        }
        this.editedRobot.robotName = ev.text;
        this.editedRobot.robotId = Number(ev.id) || -1;
    };
    UiRobotValueEditorComponent.prototype.onCancel = function () {
        if (!this.editedRobot) {
            return;
        }
        if (this.editedRobot.id === -1) {
            this.robotAssets.remove(this.editedRobot);
        }
        this.editedRobot = undefined;
    };
    UiRobotValueEditorComponent.prototype.onSave = function () {
        if (!this.editedRobot) {
            return;
        }
        if (this.formGroup.invalid ||
            this.editedRobot.robotId === -1) {
            return;
        }
        this.robotAssets.persist(this.editedRobot, this.type, this.formGroup.get('robotValue').value, this.readonly);
        this.editedRobot = undefined;
    };
    return UiRobotValueEditorComponent;
}());
export { UiRobotValueEditorComponent };
